import React from 'react';
import { useCallback } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import InfoItem from 'src/components/InfoItem';
import Button, { ButtonTypes } from 'src/components/Button';
import TextInput, { useTextInputValue } from 'src/components/TextInput';
import { useHistory } from 'react-router-dom';
import infoIcon from 'src/assets/info.svg';
import './style.scoped.css';
import PopupService from 'src/utils/PopupService';
import UserInfoService from 'src/utils/UserInfoService';
import dayjs from 'dayjs';
import { confirmQuitFlow } from 'src/utils';

const ConfirmInfo = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [email, onChangeEmail] = useTextInputValue('');
  const [address, onChangeAddress] = useTextInputValue('');

  const _handleConfirm = useCallback(() => {
    console.log('Continue ConfirmInfoSpa');
  }, [history]);

  const _handleClose = () => {
    confirmQuitFlow(history);
  };

  return (
    <div className="screen-container bg-background">
      <Toolbar
        title={t('confirm_info')}
        showClose={true}
        onClose={_handleClose}
      />
      <div className="max-w-md mx-auto screenScrollContainer">
        <div className="px-4 py-5 text-sm text-onSurfaceVariant">
          {t('request_insurrance_guide')}
        </div>
        <div className="bg-surface px-4 pt-6 pb-8">
          <div className="mb-5">
            <InfoItem
              title={t('full_name_buyer')}
              content={UserInfoService.getUserInfo()?.fullname || ''}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('identity_card_type')}
              content={UserInfoService.getUserInfo()?.idCardType}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('identity_card_number')}
              content={UserInfoService.getUserInfo()?.idCardNo}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('issued_date')}
              content={
                UserInfoService.getUserInfo()?.issueDate
                  ? dayjs(UserInfoService.getUserInfo()?.issueDate).format(
                      t('date_format1')
                    )
                  : ''
              }
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('issued_place')}
              content={UserInfoService.getUserInfo()?.issuePlace}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('phone')}
              content={UserInfoService.getUserInfo()?.mobile}
            />
          </div>
          {/* <div className="mb-5">
            <TextInput
              label={t('email')}
              placeholder={t('email_placeholder')}
              value={email}
              isRequired={true}
              onChange={_handheChangeEmail}
              error={!!errEmail}
              helperText={errEmail}
            />
          </div> */}
        </div>
      </div>
      <div className="bottomButtonBlock">
        <Button
          text={t('confirm')}
          onClick={_handleConfirm}
          extraClassName={'w-full'}
        />
      </div>
    </div>
  );
};

export default ConfirmInfo;
